import { Link } from "react-router-dom";
import { Phone, Envelope, MapPin } from "@phosphor-icons/react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_8daf730c-66f1-48f9-9ec4-f1965e82cf39/artifacts/8s88x8hu_logo_officiel-removebg-preview%20%281%29.png";

const services = [
  { name: "Plâtrerie & Isolation", path: "/services#platrerie-isolation" },
  { name: "Peinture & Décoration", path: "/services#peinture-decoration" },
  { name: "Revêtements Sols & Murs", path: "/services#revetements" },
  { name: "Ravalement de Façades", path: "/services#ravalement-facades" },
];

const quickLinks = [
  { name: "Accueil", path: "/" },
  { name: "Nos Réalisations", path: "/realisations" },
  { name: "À Propos", path: "/a-propos" },
  { name: "Contact & Devis", path: "/contact" },
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#333333] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="space-y-6">
            <img src={LOGO_URL} alt="Qualidéco" className="h-12 w-auto brightness-0 invert" />
            <p className="text-gray-300 text-sm leading-relaxed">
              Depuis plus de 25 ans, Qualidéco accompagne particuliers et professionnels dans leurs projets de rénovation et décoration en Saône-et-Loire.
            </p>
            <div className="flex items-center gap-2 flex-wrap">
              <span className="bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded">
                QUALIBAT
              </span>
              <span className="bg-green-600 text-white text-xs font-bold px-3 py-1 rounded">
                RGE
              </span>
              <span className="text-gray-400 text-sm">Entreprise certifiée</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold text-lg mb-6 font-['Barlow_Condensed'] uppercase tracking-wide">
              Nos Services
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    className="text-gray-300 hover:text-[#E74C3C] transition-colors text-sm footer-link"
                    data-testid={`footer-service-${service.name.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-6 font-['Barlow_Condensed'] uppercase tracking-wide">
              Liens Rapides
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-[#E74C3C] transition-colors text-sm footer-link"
                    data-testid={`footer-link-${link.name.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-6 font-['Barlow_Condensed'] uppercase tracking-wide">
              Contact
            </h4>
            <ul className="space-y-4">
              <li>
                <a
                  href="tel:0385392938"
                  className="flex items-center gap-3 text-gray-300 hover:text-[#E74C3C] transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone size={20} weight="fill" className="text-[#1B93A4]" />
                  <span className="text-sm">03 85 39 29 38</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:qualideco@quali-deco.fr"
                  className="flex items-center gap-3 text-gray-300 hover:text-[#E74C3C] transition-colors"
                  data-testid="footer-email"
                >
                  <Envelope size={20} weight="fill" className="text-[#1B93A4]" />
                  <span className="text-sm">qualideco@quali-deco.fr</span>
                </a>
              </li>
              <li>
                <a
                  href="https://maps.google.com/?q=306+rue+Ampère+71000+Mâcon"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-3 text-gray-300 hover:text-[#E74C3C] transition-colors"
                  data-testid="footer-address"
                >
                  <MapPin size={20} weight="fill" className="text-[#1B93A4] flex-shrink-0 mt-0.5" />
                  <span className="text-sm">306 rue Ampère<br />71000 Mâcon</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400">
            <p>© {currentYear} Qualidéco. Tous droits réservés.</p>
            <div className="flex items-center gap-6">
              <Link to="/mentions-legales" className="hover:text-white transition-colors">
                Mentions légales
              </Link>
              <Link to="/politique-confidentialite" className="hover:text-white transition-colors">
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
